/*
 * @Version: 1.0
 * @Autor: wenruihuan
 * @Date: 2022-04-03 18:29:47
 * @LastEditors: myname
 * @LastEditTime: 2022-04-03 18:50:36
 */
import commonButton from './common-button.vue'
// 这里是重点
const button = {
    install: function(Vue){
        Vue.component('commonButton', commonButton)
    }
}

// 导出组件
export default button